import { Badge } from "@shared/ui/badge";
import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/ui/tooltip";
import { AlertCircle, HelpCircle } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

export const PredictiveMaintenanceAlerts: React.FC<{ data: any }> = ({
  data,
}) => {
  const navigate = useNavigate();
  const handleSchedule = (assetId: string) => {
    navigate(`/ax/asset-registry/assets/view/${assetId}`);
  };
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <div>
            <CardTitle className="text-lg flex items-center gap-2">
              <AlertCircle className="h-5 w-5" />
              Predictive Maintenance Alerts
            </CardTitle>
          </div>
          <div className="mt-1">
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p className="max-w-xs">
                  A list of potential future failures predicted by the analytics
                  engine, allowing for proactive maintenance.
                </p>
              </TooltipContent>
            </Tooltip>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 mt-3">
          {data?.predictiveMaintenanceAlerts?.length ? (
            data.predictiveMaintenanceAlerts.map((alert, index) => (
              <div
                key={index}
                className="flex items-center justify-between p-3 bg-gray-50 rounded"
              >
                <div>
                  <p className="font-medium">{alert.assetName}</p>
                  <p className="text-sm text-gray-600">{alert.description}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <Badge variant="outline">
                      {alert.confidence} confidence
                    </Badge>
                    <span className="text-xs text-gray-500">
                      {alert.timeframe}
                    </span>
                  </div>
                </div>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => handleSchedule(alert.assetName)}
                >
                  View
                </Button>
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-500 italic text-center py-4">
              No predictive maintenance alerts available.
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
